import { Link } from 'react-router-dom';
import { useDevMode } from './DevModeProvider';
import { useQaSurfaces } from './useQaSurfaces';

/**
 * Persistent banner shown at the top of both operator shells while Dev Mode is
 * enabled (platform admin only). Shows how many QA surfaces are still
 * unverified and an Exit button. Mirrors the saffron treatment of
 * DevSchemaParityBanner so it reads as an unmistakable "you are in a special
 * mode" strip.
 */
export function DevModeBanner() {
  const { enabled, exit } = useDevMode();
  const { remaining, total, isLoading } = useQaSurfaces();

  if (!enabled) return null;

  return (
    <div
      role="status"
      className="flex items-center gap-3 border-b border-rule-strong bg-[#A8451E] px-4 py-2 text-xs text-paper"
    >
      <span className="font-medium uppercase tracking-wider">Dev Mode</span>
      <span className="text-paper/90">
        {isLoading
          ? 'verifying features…'
          : `verifying features — ${remaining} of ${total} left`}
      </span>
      <Link
        to="/dev"
        className="ml-auto underline decoration-paper/60 underline-offset-2 hover:decoration-paper"
      >
        Open hub
      </Link>
      <button
        type="button"
        onClick={exit}
        className="rounded border border-paper/50 px-2 py-0.5 uppercase tracking-wider hover:bg-paper/10"
      >
        Exit
      </button>
    </div>
  );
}
